import React from 'react';
import NavComponent from "./NavComponent";
import FormComponent from "./FormComponent";
import FooterComponentHome from "./FooterComponentHome";

function LluviaComponent() {
    return (
        <div>
            <NavComponent />
            <FormComponent />
            <FooterComponentHome />
        </div>
    );
}

export default LluviaComponent;